// components/HowItWorks.jsx — 3-step process section

import { SectionWrapper, SectionTitle } from "./UI";

export default function HowItWorks({ t, dark }) {
  return (
    <SectionWrapper id="howItWorks" dark={dark} bg="default">
      <SectionTitle title={t.howItWorks.sectionTitle} dark={dark} />

      <div className="relative grid grid-cols-1 md:grid-cols-3 gap-10">
        {/* Connector line (desktop only) */}
        <div
          className={`hidden md:block absolute top-10 left-[calc(16.67%+2rem)] right-[calc(16.67%+2rem)] h-px ${
            dark ? "bg-white/10" : "bg-[#E2E8F0]"
          }`}
        />

        {t.howItWorks.steps.map((step, i) => (
          <div key={i} className="flex flex-col items-center text-center relative">
            {/* Step number + icon */}
            <div className="relative mb-5">
              {/* Outer ring */}
              <div
                className={`w-20 h-20 rounded-2xl flex items-center justify-center text-3xl relative z-10 border-2 transition-colors ${
                  dark
                    ? "bg-white/5 border-white/10 hover:border-[#A3E635]/40"
                    : "bg-[#E2E8F0]/50 border-[#E2E8F0] hover:border-[#A3E635]/40"
                } shadow-lg`}
              >
                {step.icon}
              </div>
              {/* Step number badge */}
              <div className="absolute -top-2 -right-2 w-6 h-6 rounded-full bg-[#A3E635] text-[#0F172A] text-xs font-bold flex items-center justify-center z-20 shadow">
                {i + 1}
              </div>
            </div>

            <h3 className="text-lg font-bold mb-3">{step.title}</h3>
            <p
              className={`text-sm leading-relaxed max-w-xs ${
                dark ? "text-white/50" : "text-[#0F172A]/50"
              }`}
            >
              {step.desc}
            </p>
          </div>
        ))}
      </div>
    </SectionWrapper>
  );
}
